import React from 'react';
import { Link } from "react-router-dom"
import logo from '../logo.png'
export default function Navbar() {
    return (
        <>
            <section className="header_nav">
                <div className="dark-background">
                    <div className="container">
                        <div className="col-md-12 nopadding">
                            <div className="text_slide">
                                <marquee className="text-white">
                                    <b>
                                        A-71 SATTA, A-71 SATTA live result, A-71 SATTA chart, A-71 SATTA
                                        online result, A-71 SATTA online, A-71 SATTA result today, Gali
                                        result, Desawar result, Faridabad result, Gaziyabad result, Satta
                                        matka king, A-71 SATTA up, A-71 SATTA desawar, A-71 SATTA gali,
                                        A-71 SATTA 2019 chart, Satta baba king, Gali live result, Disawar
                                        live result, Satta Number, Matka Number, Satta.com, Satta Game, Gali
                                        Number, Delhi A-71 SATTA, Satta Bazar, A-71 SATTA 2017, A-71 SATTA
                                        2018, Gali Leak Number, Gali Single Jodi, Black Satta Result, Black
                                        A-71 SATTA, A-71 SATTA India
                                    </b>
                                </marquee>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sattalogo">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1>
                                    <a href="http://A-71 SATTA.co.in" className="blink">
                                        IPL SATTA
                                    </a>
                                </h1> */}
                                <div className='logo'>
                                        <img src={logo} alt="" />    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="login-button  d-flex justify-content-center text-center">
                                <a href="#" className="login-link">
                                    LOGIN
                                </a>
                            </h2>
                        </div>
                    </div>
                </div>
                
            </section>


        </>
    )
}
